module.exports = __webpack_public_path__ + "static/media/Asset 13RKnee.646f746f.png";